"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryNavigation = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
const ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
const ArrowDropUp_1 = __importDefault(require("@mui/icons-material/ArrowDropUp"));
const SecondaryNavigationTab_1 = require("./SecondaryNavigationTab");
const SecondaryNavigation = ({ tabs, initialTab = 0, showMenuList = true, menuListTitle = 'Menu title', menuListItems = [], navigatorVariant = 'external', }) => {
    const [value, setValue] = (0, react_1.useState)(initialTab);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleChange = (_, newValue) => {
        var _a, _b;
        setValue(newValue);
        (_b = (_a = tabs[newValue]) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const menuIcon = (0, react_1.useMemo)(() => {
        const icons = {
            internal: {
                up: react_1.default.createElement(ArrowDropUp_1.default, null),
                down: react_1.default.createElement(ArrowDropDown_1.default, null),
            },
            external: {
                up: react_1.default.createElement(KeyboardArrowUp_1.default, { color: "primary" }),
                down: react_1.default.createElement(KeyboardArrowDown_1.default, { color: "primary" }),
            },
        };
        const { up, down } = icons[navigatorVariant];
        return anchorEl ? up : down;
    }, [anchorEl, navigatorVariant]);
    return (react_1.default.createElement(material_1.Box, { sx: { width: '100%' } },
        react_1.default.createElement(material_1.Box, { sx: {
                boxShadow: navigatorVariant === 'internal' ? 2 : 4,
                display: 'flex',
                justifyContent: 'space-between',
                paddingX: navigatorVariant === 'internal' ? '4rem' : '1.5rem',
            } },
            react_1.default.createElement(material_1.Tabs, { value: value, onChange: handleChange, variant: "standard", "aria-label": "custom tabs", slotProps: {
                    indicator: {
                        sx: {
                            display: navigatorVariant === 'internal' ? 'none' : 'block',
                        },
                    },
                }, sx: {
                    '& .MuiTabs-flexContainer': {
                        gap: '1rem',
                    },
                } }, tabs.map((tab, index) => {
                const key = `tab-${tab.label}-${index}`;
                return (react_1.default.createElement(SecondaryNavigationTab_1.TabWithMenu, Object.assign({}, a11yProps(index), { variant: navigatorVariant, key: key, label: tab.label, index: index, items: tab.items })));
            })),
            showMenuList && menuListItems.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.IconButton, { disableRipple: true, onClick: handleMenuOpen, sx: { '&:hover': { bgcolor: 'transparent' }, borderRadius: 0 } },
                    react_1.default.createElement(material_1.Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4rem',
                            fontSize: '14px',
                            fontWeight: 400,
                            color: 'gray.700',
                            borderBottom: navigatorVariant === 'internal' ? '1px solid' : undefined,
                            borderColor: 'gray.300',
                            paddingY: '0.3rem',
                        } },
                        menuListTitle,
                        menuIcon)),
                react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleMenuClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' } }, menuListItems.map(({ label, action }) => (react_1.default.createElement(material_1.MenuItem, { key: label, onClick: () => {
                        action();
                        handleMenuClose();
                    } }, label))))))),
        tabs.map((tab, index) => (react_1.default.createElement(CustomTabPanel, { key: tab.label, value: value, index: index }, tab.content)))));
};
exports.SecondaryNavigation = SecondaryNavigation;
const a11yProps = (index) => ({
    id: `custom-tab-${index}`,
    'aria-controls': `custom-tabpanel-${index}`,
});
const CustomTabPanel = react_1.default.memo(({ children, value, index }) => (react_1.default.createElement("section", { role: "tabpanel", hidden: value !== index, id: `custom-tabpanel-${index}`, "aria-labelledby": `custom-tab-${index}` }, value === index && react_1.default.createElement(material_1.Box, { sx: { padding: '1rem' } }, children))));
//# sourceMappingURL=SecondaryNavigation.js.map